/* ============================================================
   HAKKIMIZDA — MUTLU FİYATLAR
   Dil değiştirici (TR/EN) + tesis galerisi lightbox + mobil menü.
   Tema JS'inden bağımsız; event delegation ile tek dinleyici.
   ============================================================ */
(function () {
  'use strict';

  // Birden fazla bölüm bu dosyayı yükleyebilir; dinleyiciler yalnızca bir kez bağlansın.
  if (window.__mfHakkimizdaInit) { return; }
  window.__mfHakkimizdaInit = true;

  var docEl = document.documentElement;

  /* ---- Dil ---- */
  function setLang(lang) {
    var l = lang === 'en' ? 'en' : 'tr';
    docEl.setAttribute('data-mf-lang', l);
    var buttons = document.querySelectorAll('.mf-lang button');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].classList.toggle('mf-on', buttons[i].getAttribute('data-lang') === l);
      buttons[i].setAttribute('aria-pressed', buttons[i].getAttribute('data-lang') === l ? 'true' : 'false');
    }
    try { localStorage.setItem('mf_lang', l); } catch (e) {}
  }

  var initial = 'tr';
  try { initial = localStorage.getItem('mf_lang') || 'tr'; } catch (e) {}
  setLang(initial);

  /* ---- Lightbox ---- */
  function openLb(fig) {
    var lb = document.getElementById('mf-lb');
    if (!lb) return;
    var en = docEl.getAttribute('data-mf-lang') === 'en';
    var title = (en ? fig.getAttribute('data-title-en') : fig.getAttribute('data-title-tr')) || '';
    var desc = (en ? fig.getAttribute('data-desc-en') : fig.getAttribute('data-desc-tr')) || '';
    var video = fig.getAttribute('data-video');
    var img = fig.querySelector('.mf-frame img');
    var frame = document.getElementById('mf-lbFrame');
    if (video) {
      var vid = document.createElement('video');
      vid.setAttribute('controls', '');
      vid.setAttribute('autoplay', '');
      vid.setAttribute('playsinline', '');
      vid.style.cssText = 'width:100%;height:100%;object-fit:cover';
      vid.src = video;
      frame.textContent = '';
      frame.appendChild(vid);
    } else if (img) {
      var im = document.createElement('img');
      im.src = img.getAttribute('src');
      im.alt = title;
      im.style.cssText = 'width:100%;height:100%;object-fit:cover';
      frame.textContent = '';
      frame.appendChild(im);
    } else {
      frame.textContent = en ? 'Fotoğraf buraya yüklenecek' : 'Buraya yüklenecek fotoğraf gelecek';
    }
    document.getElementById('mf-lbTitle').textContent = title;
    document.getElementById('mf-lbDesc').textContent = desc;
    lb.classList.add('mf-on');
    document.body.style.overflow = 'hidden';
  }

  function closeLb() {
    var lb = document.getElementById('mf-lb');
    if (!lb) return;
    lb.classList.remove('mf-on');
    document.getElementById('mf-lbFrame').textContent = '';
    document.body.style.overflow = '';
  }

  /* ---- Tek tıklama dinleyicisi (delegation) ---- */
  document.addEventListener('click', function (e) {
    var langBtn = e.target.closest('.mf-lang button');
    if (langBtn) { setLang(langBtn.getAttribute('data-lang')); return; }

    var burger = e.target.closest('.mf-burger');
    if (burger) {
      var header = burger.closest('.mf-header');
      if (header) {
        var open = header.classList.toggle('mf-nav-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    var navLink = e.target.closest('.mf-nav-main a, .mf-subnav a');
    if (navLink) {
      var h = navLink.closest('.mf-header');
      if (h) { h.classList.remove('mf-nav-open'); }
      // menüyü kapat, ama anchor gezinmeyi engelleme
    }

    var fig = e.target.closest('.mf-gal figure');
    if (fig) { openLb(fig); return; }

    var lb = e.target.closest('.mf-lb');
    if (lb) {
      if (e.target.closest('.mf-close') || !e.target.closest('.mf-box')) { closeLb(); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLb(); }
  });
})();
